import { gameState, config } from "@js/state";

export default class LoadEndScene extends Phaser.Scene {
  constructor() {
    super({
      key: "LoadEndScene",
    });
  }

  preload() {
    //the reward name will also change based on the game
  }

  create() {
    this.time.delayedCall(
      2000,
      () => {
        this.loadEndSceneImages();
        this.load.start();
      },
      this
    );

    this.time.delayedCall(
      4000,
      () => {
        this.loadEndSceneImages();
        this.load.start();
      },
      this
    );

    this.time.delayedCall(
      8000,
      () => {
        this.loadEndSceneReward();
        this.load.start();
      },
      this
    );

    this.time.delayedCall(
      12000,
      () => {
        this.loadEndSceneSpotlight();
        this.load.start();
      },
      this
    );
  }

  loadEndSceneImages() {
    this.load.image("gameOver", "assets/EndSceneAssets/Game Over.png");

    this.load.image("correctIcon", "assets/EndSceneAssets/correctIcon.png");

    this.load.image("incorrectIcon", "assets/EndSceneAssets/incorrectIcon.png");

    this.load.image("retryButton", "assets/EndSceneAssets/Retry Button.png");
    this.load.image("nextButton", "assets/EndSceneAssets/nextButton.png");

    this.load.image("endScreenOverlay", "assets/EndSceneAssets/endScreenOverlay.png");

    this.load.image("okayButton", "assets/EndSceneAssets/okaybutton.png");

    this.load.image("rewardEarned", "assets/EndSceneAssets/Rewards earned!.png");

    this.load.image("rewardName", "assets/EndSceneAssets/Trophy.png");

    this.load.image("retry_button_on", "assets/EndSceneAssets/retry_button_on.png");
    this.load.image("next_button_on", "assets/EndSceneAssets/next_button_on.png");
    this.load.image("okay_button_on", "assets/EndSceneAssets/okay_button_on.png");
    this.load.image("okayDisabled", "assets/EndSceneAssets/okayDisabled.png");
    this.load.image("youWon", "assets/EndSceneAssets/You won.png");
  }

  loadEndSceneReward() {
    this.load.atlas("rewardAnim_1", "assets/reward anim new/rewardAnim-1-0.png", "assets/reward anim new/rewardAnim-1.json");
    this.load.atlas("rewardAnim_2", "assets/reward anim new/rewardAnim-2-0.png", "assets/reward anim new/rewardAnim-2.json");
    this.load.atlas("rewardAnim_3", "assets/reward anim new/rewardAnim-3-0.png", "assets/reward anim new/rewardAnim-3.json");
    this.load.atlas("rewardAnim_4", "assets/reward anim new/rewardAnim-4-0.png", "assets/reward anim new/rewardAnim-4.json");
    this.load.atlas("rewardAnim_5", "assets/reward anim new/rewardAnim-5-0.png", "assets/reward anim new/rewardAnim-5.json");
  }

  loadEndSceneSpotlight() {
    this.load.atlas("spotlight_1", "assets/Spotlight New/SpotlightAnim-1-0.png", "assets/Spotlight New/SpotlightAnim-1.json");
    this.load.atlas("spotlight_2", "assets/Spotlight New/SpotlightAnim-2-0.png", "assets/Spotlight New/SpotlightAnim-2.json");
    this.load.atlas("spotlight_3", "assets/Spotlight New/SpotlightAnim-3-0.png", "assets/Spotlight New/SpotlightAnim-3.json");
    this.load.atlas("spotlight_4", "assets/Spotlight New/SpotlightAnim-4-0.png", "assets/Spotlight New/SpotlightAnim-4.json");
    this.load.atlas("spotlight_5", "assets/Spotlight New/SpotlightAnim-5-0.png", "assets/Spotlight New/SpotlightAnim-5.json");
    this.load.atlas("spotlight_6", "assets/Spotlight New/SpotlightAnim-6-0.png", "assets/Spotlight New/SpotlightAnim-6.json");
  }

  update() {}
}
